import { HEADER_HEIGHT, MOBILE_DOT_WRAPPER_TOP } from "./constants";

const MobileLayout = function (windowSize, isMobile, isTablet, isIOS, isOpen, isFormFocused, isHovered, position, collapsedStyle, config) {
  var layout, wrapperStyle, clickWrapperStyle, swivlEmbedStyle, chatWrapperStyle;

  const arrowTransform = isOpen ? "rotate(0deg)" : "rotate(180deg)";

  layout = {
    position: position,
    width: windowSize.width,
    height: windowSize.height,
    headerHeight: HEADER_HEIGHT,
    leftPadding: 0,
    rightPadding: 0
  };
  // const openYTranslate = (isFormFocused) ? "translate(0,-55px)" : "translate(0,0)";
  // const openHeight = (isFormFocused) ? windowSize.height + layout.headerHeight + "px" : windowSize.height + "px"

  //// NOTE: This  sometimes  give better results but it is inconsistant.
  const openYTranslate = false ? "translate(0,-55px)" : "translate(0,0)";
  let openHeight = false ? windowSize.height + layout.headerHeight + "px" : windowSize.height + "px";

  if (navigator.userAgent.indexOf("iPhone OS 15") != -1) {
    if (isFormFocused) {
      // if (navigator.userAgent.indexOf("iPhone OS 15") != -1) {
      const openOffset = windowSize.height > 700 ? 118 : 90;
      openHeight = "calc(100vh - (env(safe-area-inset-bottom) + env(safe-area-inset-top) + " + openOffset + "px))";
      // openHeight = "calc(100vh - env(safe-area-inset-bottom))

      // }
    } else {
      openHeight = "calc(" + windowSize.height + "px - (env(safe-area-inset-bottom) + env(safe-area-inset-top)))";
    }
    // openHeight = "calc(" + windowSize.height + "px - (env(safe-area-inset-bottom) + env(safe-area-inset-top)))"
  }

  const wrapperTop = collapsedStyle == "dot" && !isOpen ? MOBILE_DOT_WRAPPER_TOP + "px" : 0;

  wrapperStyle = {
    top: wrapperTop,
    left: 0,
    position: "fixed",
    width: windowSize.width + "px",
    height: openHeight,
    transform: isOpen ? openYTranslate : "translate(0, " + (windowSize.height - layout.headerHeight) + "px)",
    transition: "all 0.4s"
  };

  clickWrapperStyle = {
    position: isOpen ? "absolute" : "fixed",
    // background:"#000",
    bottom: 0,
    left: 0,
    right: 0,
    // top:(isOpen) ? "0" : "auto",
    height: openHeight, //  (isOpen) ? openHeight + "px" : layout.headerHeight  + "px",
    width: Math.min(layout.width, windowSize.width) + "px",
    transition: "all 0.4s",
    overflow: "hidden"
  };
  if (collapsedStyle != "dot" && !isOpen) {
    clickWrapperStyle.top = "10px";
    clickWrapperStyle.overflow = "visible";
    wrapperStyle.top = "-10px";
  }

  swivlEmbedStyle = {
    position: "absolute",
    left: 0,
    right: 0,
    height: openHeight,
    width: windowSize.width + "px",
    top: 0,
    transition: "all 0.2s linear",
    borderRadius: isOpen ? "0" : "25px 25px 0 0",
    overflow: "hidden"
  };

  var chatWrapperBottom = "0";
  if (isIOS && isFormFocused && !isTablet) {
    // chatWrapperBottom = "294px"; // This may not be nessesary.
  }
  chatWrapperStyle = {
    position: "absolute",
    top: layout.headerHeight + "px",
    bottom: chatWrapperBottom,
    right: "0",
    left: "0",
    transition: "all 0.2s linear"
  };

  if (collapsedStyle == "dot") {
    clickWrapperStyle.bottom = isOpen ? "0" : "-60px";
  }

  return {
    layout: layout,
    wrapperStyle: wrapperStyle,
    clickWrapperStyle: clickWrapperStyle,
    swivlEmbedStyle: swivlEmbedStyle,
    chatWrapperStyle: chatWrapperStyle,
    arrowTransform: arrowTransform
  };
};

export default MobileLayout;
